/** Nettlesernøkkelen er begrenset på domene og API i Google Cloud, så den kan ligge i klienten (VIB-2938). */
export const GOOGLE_MAPS_API_KEY = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ?? "";
export const GOOGLE_MAPS_MAP_ID = (import.meta.env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined) ?? "";
export const hasGoogleMaps = (): boolean => GOOGLE_MAPS_API_KEY.length > 0;

/** Merkevarefargene på kartet (plan § 5.3b): pinner i Reveblå, valgt pinne og klynger i Revemørk. */
export const REVEBLAA = "#031EFF";
export const REVEMOERK = "#081F3B";
